<template>
    <div class="page-content" id="p">
        <div class="detail-body">
            <div v-loading="loading" class="detail-content">
                <div class="content-head">
                    <div class="detail-title">
                        <div class="title-name">{{detail.title}}</div>
                        <div v-if="detail.is_collection===1" @click="setCollection('del')" class="title-right" style="margin-left: auto;">
                            <i class="el-icon-star-off color-red"></i>
                            <span class="color-red">已收藏</span>
                        </div>
                        <div v-else class="title-right" @click="setCollection('add')" style="margin-left: auto;">
                            <i class="el-icon-star-off"></i>
                            收藏
                        </div>
                        <el-popover
                                placement="bottom-start"
                                title="分享"
                                width="200"
                                trigger="hover">
                            <div slot="reference" class="title-right">
                                <i class="el-icon-share"></i>
                                分享
                            </div>
                            <div data-sites="qzone, qq, weibo, wechat" class="social-share"></div>
                        </el-popover>
                    </div>
                    <!--<div class="head-address">
                        <i class="el-icon-location"></i>
                        <div class="f-14">{{detail.address}}</div>
                    </div>-->
                    <div class="swiper-content">
                        <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                            <swiper-slide class="swiper-slide" v-for="(item,index) in detail.image" :key="index">
                                <img :src="`/api/v1/file/${item}?w=378&h=210`" alt="">
                            </swiper-slide>
                        </swiper>
                        <!-- swiper2 Thumbs -->
                        <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                            <swiper-slide class="swiper-slide" v-for="(item,index) in detail.image" :key="index">
                                <img :src="`/api/v1/file/${item}?w=126&h=70`" alt="">
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="content-body">
                    <div class="content-title">路线介绍</div>
                    <div class="content-text" v-html="content"></div>
                    <div class="color-grays f-14 mt-10 mb-10 tran-content">
                        是否使用谷歌翻译
                        <template v-if="!traning">
                            <el-link class="ml-20" type="primary" @click="trans('zh')">翻译为中文</el-link>
                            <el-link class="ml-10" type="primary" @click="trans('jp')">翻译为日文</el-link>
                        </template>
                        <el-link v-else class="ml-10" type="primary">翻译中...</el-link>
                    </div>
                    <div class="content-text" v-for="(item,index) in transList" :key="index">{{item.dst}}</div>


                    <div class="content-title">路线须知</div>
                    <div class="content-text" v-html="prompt"></div>
                    <div class="content-title">人均消费</div>
                    <div class="content-text color-red">{{detail.price|parseMoney}}/车</div>
                    <div class="content-title">退款规则</div>
                    <div class="content-text" v-for="(item,index) in driverRules" :key="index">{{item.title}}</div>
                </div>
                <div v-if="detail.tourists.length" class="content-title" style="padding: 0 20px;">相似路线</div>
                <div v-if="detail.tourists.length" class="card-content" style="width: 100%;">
                    <template v-for="(item,index) in detail.tourists">
                        <LineCard :key="index" :item="item" v-if="index<12"></LineCard>
                    </template>
                </div>
            </div>
            <div class="detail-right">
                <div class="detail-right-content">
                    <div class="right-title">预定信息</div>
                    <div class="f-14 content-text">
                        <span class="color-red">
                            {{detail.price|parseMoney}}
                        </span>/车
                    </div>
                    <div class="evaluate-content">
                        <el-rate :value="+detail.star|| 0"
                                 disabled
                                 show-score
                                 disabled-void-color="#cccccc"
                                 text-color="#ff9900"
                                 style="display: flex;justify-content: flex-start;align-items: center"
                                 score-template="{value}"></el-rate>
                        <div class="f-14">{{detail.evaluate_count}} 评价</div>
                    </div>
                    <div class="btn-item bc-color-red color-fff">申请预订</div>
                </div>
                <div class="detail-right-content">
                    <div class="right-title">导游信息</div>
                    <div class="img-row" @click="toDriverDetail">
                        <img v-if="detail.portrait" :src="`/api/v1/file/${detail.portrait}`" alt="">
                        <div class="f-16 nick-name">{{detail.nickname}}</div>
                    </div>
                    <div class="btn-item bc-color-yellow color-fff" @click="handlerLink">联系导游</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import LineCard from "@/components/LineCard";

    export default {
        name: "lineDetail",
        components:{LineCard},
        data() {
            return {
                id: '',
                loading: false,
                traning: false,
                transList: [],
                detail: {
                    tourists: []
                },
                content: '',
                prompt: '',
                driverRules: [],
                swiperOptionTop: {
                    loop: true,
                    loopedSlides: 5, // looped slides should be the same
                    spaceBetween: 10
                },
                swiperOptionThumbs: {
                    loop: true,
                    spaceBetween: 10,
                    loopedSlides: 5, // looped slides should be the same
                    slidesPerView: 5,
                    touchRatio: 0.2,
                    direction: 'vertical',
                    slideToClickedSlide: true,
                    centeredSlides: false
                },
                config: {
                    title: '', // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
                    description: '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
                    image: '', // 图片, 默认取网页中第一个img标签
                    sites: ['qzone', 'qq', 'weibo', 'wechat']
                }
            }
        },
        mounted() {
            this.id = this.$route.query.id;
            this.getTouristLook();
            this.getDriverRules();
            setTimeout(() => {
                app.scrollTop = 0;
            }, 0)
        },
        methods: {
            handlerLink() {
                this.$store.commit('initChartData', {
                    id: this.detail.user_id,
                    info: {
                        nickname: this.detail.nickname,
                        avar: this.detail.portrait,
                    }
                })
                this.$eventBus.$emit('openChart', {
                    id: this.detail.user_id,
                    name: this.detail.nickname
                })
            },
            async trans(to){
                this.traning = true;
                let [e, data] = await this.$api.transApi({to, q: this.detail.content})
                this.traning = false;
                this.transList = data.result;
            },
            async getTouristLook() {
                this.loading = true;
                let [e, data] = await this.$api.getTouristLookApi({
                    id: this.id
                })
                this.loading = false;
                this.detail = data.result;
                if(this.detail.content){
                    this.content = this.detail.content.replace(/\n/g, '<br>')
                }
                if(this.detail.prompt){
                    this.prompt = this.detail.prompt.replace(/\n/g, '<br>')
                }
                this.$nextTick(() => {
                    const swiperTop = this.$refs.swiperTop.$swiper
                    const swiperThumbs = this.$refs.swiperThumbs.$swiper
                    swiperTop.on('slideChange',(r)=>{
                        swiperThumbs.slideToLoop(r.realIndex, 500)
                    })
                    swiperThumbs.on('slideChange',(r)=>{
                        swiperTop.slideToLoop(r.realIndex, 500)
                    })
                })

                this.config.title = this.detail.title;
                this.config.description = this.detail.title;
                this.config.image = this.detail.cover;
                socialShare('.social-share', this.config)
            },
            async getDriverRules(){
                let [e, data] = await this.$api.getDriverRulesApi();
                this.driverRules = data.result;
            },
            async setCollection(method){
                let [e, data] = await this.$api.setCollectionApi({
                    id: this.detail.id,
                    mark: 6,
                    method
                })
                if(data.code === 200){
                    if(method==='add'){
                        this.detail.is_collection = 1;
                    }else {
                        this.detail.is_collection = 0;
                    }
                }else{
                    this.$message.warning(data.error)
                }
            },
            toDriverDetail(){
                this.$router.push({path: '/driverDetail', query:{id: this.detail.user_id}})
            }
        }
    }
</script>

<style scoped lang="less">
    .page-content {
        display: flex;
        padding-bottom: 30px;
    }

    .detail-body {
        width: 1200px;
        margin-top: 20px;
        margin-left: auto;
        margin-right: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
    }

    .detail-content {
        width: 900px;
        margin-right: 20px;
        background-color: #ffffff;
        box-shadow: 3px 3px 6px #A6A6A6;

        .content-head {
            width: 100%;
            padding: 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;

            .detail-title {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .title-name {
                    font-size: 26px;
                }

                .title-right {
                    padding-left: 20px;
                    cursor: pointer;
                }
            }

            .head-address {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #949494;
                margin: 4px 0;

                .bmap-img {
                    margin-left: 20px;
                    margin-right: 10px;
                }
            }
            .head-bottom{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding-top: 20px;
                .head-bottom-icon{
                    width: 30px;
                    height: 30px;
                    object-fit: contain;
                    margin-right: 10px;
                }
                .icon-text{
                    margin-right: 20px;
                }
            }
        }
        .content-body{
            padding: 10px 30px 30px 30px;
            box-sizing: border-box;
            width: 100%;
            text-align: left;
            border-bottom: 1px solid #e2e2e2;
        }
    }

    .detail-right {
        flex: 1;
        position: sticky;
        top: 100px;
        left: 0;
        z-index: 2;

        .detail-right-content{
            padding: 20px;
            background-color: #ffffff;
            box-shadow: 3px 3px 6px #A6A6A6;
            text-align: left;
            margin-bottom: 20px;
            .right-title{
                font-size: 18px;
                font-weight: bold;
                margin-bottom: 10px;
            }
            .evaluate-content{
                display: flex;
                justify-content: space-between;
                align-items: center;
            }
            .btn-item{
                width: 100%;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                text-align: center;
                margin-top: 20px;
                cursor: pointer;
            }
            .img-row{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin-bottom: 10px;
                cursor: pointer;
                img{
                    width: 40px;
                    height: 40px;
                    border-radius: 100%;
                    object-fit: cover;
                    margin-right: 10px;
                }
                .nick-name{
                    font-weight: bold;
                }
                &:hover{
                    .nick-name{
                        color: #e44646 !important;
                    }
                }
            }
        }
    }

    .swiper-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .gallery-top {
            width: 694px;
            height: 390px;
            margin-right: 20px;
        }
        .gallery-thumbs{
            width: 126px;
            height: 390px;
        }
        .swiper-slide {
            width: 100%;
            height: 100%;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover
            }
        }

    }

    .content-title{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
    }
    .content-text{
        font-size: 14px;
        line-height: 2;
    }
    .icon-list{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-flow: wrap;
        .icon-list-item{
            color: #949494 !important;
            width: 10%;
            margin-bottom: 20px;
            text-align: center;

            .iconfont{
                font-size: 38px;
            }
        }
    }
    .map-content{
        width: 100%;
        height: 240px;
    }
</style>
<style>
    .gallery-thumbs .swiper-slide-active{
        border: 2px solid #e44646 !important;
    }
</style>
